import React from 'react';
// @mui
import { Grid } from '@mui/material';
// components
import RTextField from '../../componentes/forms/inputs/RTextField';
import RSelect from '../../componentes/forms/inputs/RSelect';

// ----------------------------------------------------------------------

export default function BusqForm({ showLoader, actualizaCampo, busqueda, provincias, oficinas }) {
  React.useEffect(() => {
    showLoader(false);
    // eslint-disable-next-line
  },[]);

  return (
    <form style={{ width: '100%'}}>
      <Grid container spacing={1}>
        <RTextField type="text" name="texto" label="Texto Búsqueda" actualizaCampo={actualizaCampo} value={busqueda.texto} md={3} />
        <RSelect name="provincia" label="Provincia" actualizaCampo={actualizaCampo} value={busqueda.provincia} md={3}
          values={provincias}
        />
        <RTextField type="text" name="semantico" label="Texto" actualizaCampo={actualizaCampo} value={busqueda.semantico} md={3} />
        <RSelect name="oficina" label="Oficina" actualizaCampo={actualizaCampo} value={busqueda.oficina} md={3}
          values={oficinas}
        />
      </Grid>
    </form>
  );
}
